var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ak-html-read-only" }, [
    _vm.isHtml
      ? _c("iframe", {
          staticClass: "ak-html-read-only__frame",
          attrs: { srcdoc: _vm.value, sandbox: "", title: "Mail inhoud" },
        })
      : _c("div", { staticClass: "ak-html-read-only__text" }, [
          _vm._v(_vm._s(_vm.value || "Geen inhoud beschikbaar.")),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }